import SalesClosing from "./settings/salesClosing";
import { Home } from "./home";

import AllInOneDraw from "./dev/AllInOneDraw";
import DevMonitor from "./dev/DevMonitor";
import { General, MailSetting, Prices, Tools, Popup, Banners } from "./settings";
import Price from "./settings/Price";

import { Admins } from "./admins";
import { Complains } from "./complains";
import LogList from "./logs/LogList";
import { Login } from "./login.jsx";

import BadLotteries from "./lotteries/badLotteries";
import OffBlockOrder from "./lotteries/OffBlockOrder";
import Imported from "./lotteries/Imported";
import LotteriesOnBlock from "./lotteries/lotteriesOnBlock";
import LotteriesDetail from "./lotteries/LotteriesDetail";

import DownloadImage from "./lotteries/DownloadImage";

import { MakeReward } from "./prizes";

import PrizesList from "./prizes/List";

import WithdrawList from "./withdraw/withdrawList";
import WithdrawPendingList from "./withdraw/withdrawPending";
import WithdrawApprovedList from "./withdraw/withdrawApproved";

import { Users, UserInfo, UserCreate } from "./users";
import { AffiliateOrder } from "./affiliates";
import {
  ManageLotteries,
  LotteriesNotOnBlock,
  ImportReport,
} from "./lotteries";
import { ManagePromoCode, PromoCodeOrders } from "./promoCode";

import { ManageDonate, DonateOrders, DonateOrderInfo } from "./donates";

import {
  ManageCoupon,
  ManageBundle,
  CouponOrderInfo,
  CouponOrders,
  CreateCouponOrder,
  BundleOrderInfo,
} from "./coupons";

import { ManageMission, MissionDetail, MissionOrders } from "./missions";

import {
  ReportDailySale,
  ReportDailySaleHourly,
  ReportMails,
  ReportRewardwinner,
  ReportLotterieBooksImport,
  ReportOrder,
  ReportPointRedeem,
  RoundDateBuyerList,
  ReportTopBuyer,
  ReportShop,
  ReportAdminApproved,
  ReportCoupon,
  ReportUserPrizes,
  ReportReserveOrder,
  ReportAdminCommission,
  ReportVerifiedUser,
  ReportRounddateNewUser,
  ReportNetIncome,
  ReportOrderDiscount,
  ReportWinner,
  ReportWinnerBook,
  ReportButtonClick,
  ReportUserYear,
  ReportTaxInvoice,
  ReportAffiliate,
  ReportTaxCoupon,
  ReportAllUser,
  ReportPromoCodeCreated,
} from "./reports";
import {
  FiHome,
  FiCreditCard,
  FiSettings,
  FiGift,
  FiUsers,
  FiFrown,
  FiVideo,
  FiFileText,
  FiLink,
  FiCheckSquare,
  FiAward,
} from "react-icons/fi";
import { ManageTrackingLinks, TrackingLinkDetail } from "./trackingLinks";
import { GrBike } from "react-icons/gr";
import { GiThreeFriends } from "react-icons/gi";
import { RxDashboard } from "react-icons/rx";

import {
  ManageProducts,
  ProductOrders,
  ProductOrderInfo,
  CreateProductOrder,
} from "./products";
import { IoReceiptOutline } from "react-icons/io5";
import { BiMoneyWithdraw } from "react-icons/bi";
import { RiCoupon2Line } from "react-icons/ri";
import { TbBrandProducthunt } from "react-icons/tb";
import { RiStore2Line } from "react-icons/ri";
import { BiDonateHeart } from "react-icons/bi";
import { RiAdminLine } from "react-icons/ri";
import LogOut from "./Logout";
import { RealtimeOrderDashboard, AnnualReport } from "./dashboard";
import {
  CreateOrder,
  Cart,
  OrderInfo,
  Orders,
  OrdersOffline,
  OrdersMail,
  OrdersReserve,
  TaxRequest,
  OrdersLine,
  OrdersCoupon,
  TransferRequestsPage,
} from "./orders";

import { RiDiscountPercentLine } from "react-icons/ri";
import { AdminCenter } from "./adminCenter";
import { SurveysPage } from "./surveys";
import { FaStar } from "react-icons/fa6";

const pages = [
  {
    path: "/login",
    component: <Login />,
    icon: <FiHome />,
    name: "เข้าสู่ระบบ",
    children: [],
    hideFromPermission: true,
    hideSideBar: true,
  },
  {
    path: "/logout",
    component: <LogOut />,
    icon: <FiHome />,
    name: "ออกจากระบบ",
    children: [],
    hideFromPermission: true,
    hideSideBar: true,
  },
  {
    hideSideBar: true,
    path: "/",
    component: <Home />,
    icon: <FiHome />,
    name: "หน้าหลัก",
    children: [],
  },

  {
    path: "/dashboard",
    component: <RealtimeOrderDashboard />,
    hideSideBar: true,
    name: "แดชบอร์ด",
    children: [],
    permissions: ["dev", "superAdmin", "superScanner", "superAccount"],
  },
  {
    path: "/realtime-dashboard",
    component: <RealtimeOrderDashboard />,
    icon: <RxDashboard />,
    name: "แดชบอร์ด",
    children: [],
    permissions: ["dev", "superAdmin", "superScanner", "superAccount"],
  },
  {
    path: "/annual-report",
    component: <AnnualReport />,
    icon: <FiAward />,
    name: "สรุปประจำปี",
    children: [],
    permissions: ["dev", "superAdmin"],
  },
  {
    path: "/admin-center",
    component: <AdminCenter />,
    icon: <RiAdminLine />,
    name: "แอดมิน",
    children: [],
    permissions: [
      "dev",
      "superAdmin",
      "admin",
    ],
  },

  {
    path: "/lotteries",
    icon: <FiCreditCard />,
    name: "ลอตเตอรี่",
    permissions: ["dev", "superAdmin", "admin", "superScanner", "scanner"],
    children: [
      {
        path: "/lotteries/manage",
        component: <ManageLotteries />,
        name: "จัดการลอตเตอรี่",
        permissions: ["dev", "superScanner", "scanner"],
      },
      {
        path: "/lotteries/import-history",
        component: <ImportReport />,

        name: "การนำเข้าลอตเตอรี่",
        permissions: ["dev", "superAdmin", "admin", "superScanner", "scanner"],
      },
      {
        path: "/lotteries/unimported",
        component: <BadLotteries />,
        icon: "lotteries.png",
        name: "ลอตเตอรี่ที่มีปัญหา",
        permissions: ["dev", "superScanner", "scanner"],
      },
      {
        path: "/lotteries/all",
        component: <Imported />,
        icon: "lotteries.png",
        name: "ลอตเตอรี่ในระบบทั้งหมด",
        permissions: ["dev", "superAdmin", "admin", "superScanner", "scanner"],
      },

      {
        path: "/lotteries/notImported",
        component: <LotteriesNotOnBlock />,
        icon: "lotteries.png",
        name: "เล่มลอตเตอรี่ในระบบหลังบ้าน",
        permissions: ["dev", "superScanner", "scanner"],
      },

      {
        path: "/lotteries/imported",
        component: <LotteriesOnBlock />,
        icon: "lotteries.png",
        name: "เล่มลอตเตอรี่ในระบบพร้อมขาย",
        permissions: ["dev", "superScanner", "scanner"],
      },
      {
        hideSideBar: true,
        path: "/lotteries/detail",
        component: <LotteriesDetail />,
        name: "ข้อมูลเล่มลอตเตอรี่",
        permissions: ["dev", "superScanner", "scanner"],
      },

      // {
      //   path: "/lotteries/check-book",
      //   component: <CheckBookLotteries />,
      //   name: "ตรวจเล่มลอตเตอรี่",
      //   permissions: ["dev", "superScanner", "scanner"],
      // },
      // {
      //   hideSideBar: true,
      //   path: "/lotteries/bookList",
      //   Component: <BookList />,
      //   icon: "lotteries.png",
      //   name: "รายการเล่มลอตเตอรี่",
      //   permissions: ["dev"],
      // },
      {
        path: "/coupon/list/reserved",
        component: <CouponOrders initialTab="reserve" initialType="reserve" />,
        name: "คูปองจองสิทธิ์",
        permissions: ["dev", "superAdmin", "admin", "superScanner", "scanner"],
      },
      // {
      //   path: "/lotteries/adminOrder",
      //   Component: <OffBlockOrder />,
      //   icon: "lotteries.png",
      //   name: "จองลอตเตอรี่",
      //   permissions: ["dev"],
      // },
      {
        path: "/lotteries/test1",
        component: <DownloadImage />,
        icon: "lotteries.png",
        name: "โหลดรูป",
        permissions: ["dev"],
        hideFromPermission: true,
        hideSideBar: true,
      },
      {
        path: "/lotteries/test2",
        component: <OffBlockOrder />,
        icon: "lotteries.png",
        name: "---------------",
        permissions: ["dev"],
        hideFromPermission: true,
        hideSideBar: true,
      },
    ],
  },
  {
    path: "/orders",
    icon: <IoReceiptOutline />,
    name: "คำสั่งซื้อสลาก",
    permissions: [
      "dev",
      "superAdmin",
      "admin",
      "superScanner",
      "scanner",
      "superAccount",
      "account",
    ],
    children: [
      {
        path: "/orders",
        component: <Orders />,
        icon: "orders.png",
        name: "คำสั่งซื้อสลากทั้งหมด",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "superAccount",
        ],
      },
      {
        path: "/orders/approved",
        component: <Orders />,
        icon: "orders.png",
        name: "คำสั่งซื้อสลากสำเร็จ",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "superAccount",
        ],
      },
      {
        path: "/orders/paid",
        component: <Orders />,
        icon: "orders.png",
        name: "คำสั่งซื้อสลากรออนุมัติ",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "superAccount",
        ],
      },
      {
        path: "/orders/pending",
        component: <Orders />,
        icon: "orders.png",
        name: "คำสั่งซื้อสลากรอชำระ",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "superAccount",
        ],
      },
      {
        path: "/orders/canceled",
        component: <Orders />,
        icon: "orders.png",
        name: "คำสั่งซื้อสลากยกเลิก",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "superAccount",
        ],
      },
      {
        path: "/orders/mail",
        component: <OrdersMail />,
        icon: "orders.png",
        name: "คำสั่งซื้อสลากทางไปรษณีย์",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "superAccount",
        ],
      },
      {
        path: "/orders/offline",
        component: <OrdersOffline />,
        icon: "orders.png",
        name: "คำสั่งซื้อสลาก 80 บาท",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "superAccount",
        ],
      },

      {
        path: "/promocode/orders",
        component: <PromoCodeOrders />,
        name: "คำสั่งซื้อสลากที่ใช้โค้ดส่วนลด",
        permissions: [
          "dev",
          "superAdmin",
          "superScanner",
          "scanner",
          "marketing",

          "admin",
        ],
      },
      {
        path: "/orders/line",
        component: <OrdersLine />,
        icon: "orders.png",
        name: "คำสั่งซื้อสลาก LINE",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "superAccount",
        ],
      },
      {
        path: "/orders/reserve",
        component: <OrdersReserve />,
        icon: "orders.png",
        name: "คำสั่งซื้อสลากจากคูปองจองสิทธิ์",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "superAccount",
        ],
      },
      {
        path: "/orders/coupon",
        component: <OrdersCoupon />,
        icon: "orders.png",
        name: "คำสั่งซื้อสลากที่ใช้คูปอง",
        permissions: [
          "dev",
          "superAdmin",
          "superScanner",
          "scanner",
          "marketing",
          "admin",
        ],
      },
      {
        path: "/orders/transfer-requests",
        component: <TransferRequestsPage />,
        icon: "orders.png",
        name: "คำขอย้ายเจ้าของคำสั่งซื้อ",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "superAccount",
          "account",
        ],
      },

      // {
      //   path: "/orders/tax-request",
      //   component: <TaxRequest />,
      //   icon: "orders.png",
      //   name: "คำขอใบกำกับภาษี",
      //   permissions: ["dev", "superAdmin", "admin", "superAccount", "account"],
      // },
      {
        path: "/orders/:orderId",
        component: <OrderInfo />,
        icon: "orders.png",
        name: "ข้อมูลคำสั่งซื้อสลาก",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "superAccount",
        ],
        hideSideBar: true,
      },
      {
        path: "/orders/cart",
        component: <Cart />,
        icon: "orders.png",
        name: "ตะกร้า",
        permissions: ["dev", "superAdmin", "admin", "superScanner", "scanner"],
      },
      {
        path: "/orders/create/:userId",
        component: <CreateOrder />,
        icon: "orders.png",
        name: "สร้างออเดอร์",
        permissions: ["dev", "superAdmin", "admin"],
        hideSideBar: true,
      },
      {
        path: "/reports/tax",
        component: <TaxRequest />,
        name: "รายงานคำสั่งซื้อสลาก",
        permissions: ["dev", "superAdmin", "superScanner", "superAccount"],
      },
      // {
      //   path: "/reports/order/discount",
      //   component: <ReportOrderDiscount />,
      //   name: "รายงานคำสั่งซื้อสลากลดราคา",
      //   permissions: ["dev", "superAdmin", "superScanner", "superAccount"],
      // },
    ],
  },
  {
    path: "/coupons",
    icon: <RiCoupon2Line />,
    name: "คูปอง",
    permissions: [
      "dev",
      "superAdmin",
      "admin",
      "superScanner",
      "scanner",
      "superAccount",
      "account",
      "marketing",
    ],
    children: [
      {
        path: "/coupon/manage",
        component: <ManageCoupon />,
        name: "จัดการคูปอง",
        permissions: ["dev", "superAdmin", "admin", "marketing"],
      },
      {
        path: "/coupon/bundle",
        component: <ManageBundle />,
        name: "ชุดแพ็กเกจสลาก",
        permissions: ["dev", "superAdmin", "admin", "marketing"],
        hideSideBar: true,
      },

      {
        path: "/coupon/orders",
        component: <CouponOrders />,
        name: "คำสั่งซื้อคูปองทั้งหมด",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "superAccount",
          "account",
        ],
      },
      {
        path: "/coupon/orders/voucher",
        component: <CouponOrders initialType="voucher" />,
        name: "คำสั่งซื้อคูปองสลาก",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "superAccount",
          "account",
        ],
      },
      {
        path: "/coupon/orders/discount",
        component: <CouponOrders initialType="discount" />,
        name: "คำสั่งซื้อคูปองส่วนลด",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "superAccount",
          "account",
        ],
      },
      {
        path: "/coupon/orders/reserve",
        component: <CouponOrders initialTab="reserve" initialType="reserve" />,
        name: "คำสั่งซื้อคูปองจองสิทธิ์",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "superAccount",
          "account",
        ],
      },
      {
        path: "/coupon/orders/vip",
        component: <CouponOrders initialType="vip" />,
        name: "คำสั่งซื้อคูปอง VIP",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "superAccount",
          "account",
        ],
      },

      {
        path: "/coupon/orders/mission",
        component: <CouponOrders initialType="mission" />,
        name: "คำสั่งซื้อคูปองรางวัลภารกิจ",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "superAccount",
          "account",
        ],
      },
      {
        path: "/coupon/orders/voucher-lock",
        component: <CouponOrders initialType="voucher-lock" />,
        name: "คำสั่งซื้อคูปองล็อคเลข",
        hideSideBar: true,
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "superAccount",
          "account",
        ],
      },
      {
        path: "/coupon/orders/bundle",
        component: <CouponOrders initialTab="bundle" />,
        name: "คำสั่งซื้อชุดแพ็กเกจ",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "superAccount",
          "account",
        ],
      },
      {
        path: "/coupon/bundle-orders",
        component: <CouponOrders initialTab="bundle" />,
        name: "คำสั่งซื้อชุดแพ็กเกจ",
        hideSideBar: true,
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "superAccount",
          "account",
        ],
      },

      {
        path: "/coupon/bundle/:orderId",
        component: <BundleOrderInfo />,
        name: "รายละเอียดคำสั่งซื้อแพ็กเกจ",
        permissions: ["dev", "superAdmin", "admin", "superAccount", "account"],
        hideSideBar: true,
      },

      // {
      //   path: "/reports/coupon",
      //   component: <ReportCoupon />,
      //   name: "รายงานคูปอง",
      //   permissions: ["dev", "superAdmin", "superAccount", "account"],
      // },
      {
        path: "/coupon/order/create/:userId",
        component: <CreateCouponOrder />,
        icon: "orders.png",
        name: "สร้างออเดอร์",
        permissions: ["dev", "superAdmin", "admin"],
        hideSideBar: true,
      },

      {
        path: "/coupon/:orderId",
        component: <CouponOrderInfo />,

        icon: "orders.png",
        name: "รายละเอียดคำสั่งซื้อคูปอง",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "scanner",
          "superScanner",
          "superAccount",
          "account",
        ],

        hideSideBar: true,
      },
    ],
  },

  {
    path: "/promocode",
    icon: <RiDiscountPercentLine />,
    name: "โค้ดส่วนลด",
    permissions: [
      "dev",
      "superAdmin",
      "admin",
      "superAccount",
      "account",
      "superScanner",
      "marketing",
      "scanner",

    ],
    children: [
      {
        path: "/promocode/manage",
        component: <ManagePromoCode />,
        name: "จัดการโค้ดส่วนลด",
        permissions: [
          "dev",
          "superAdmin",
          "superScanner",
          "scanner",
          "marketing",

          "admin",
        ],
      },
      {
        path: "/promocode/orders",
        component: <PromoCodeOrders />,
        name: "คำสั่งซื้อที่ใช้โค้ด",
        permissions: [
          "dev",
          "superAdmin",
          "superScanner",
          "scanner",
          "marketing",

          "admin",
        ],
      },
      {
        path: "/reports/promocode-created",
        component: <ReportPromoCodeCreated />,
        name: "รายงานการสร้างโค้ดส่วนลด",
        permissions: [
          "dev",
          "superAdmin",
          "superScanner",
          "marketing",
          "superAccount",
        ],
      },
    ]
  },
  {
    path: "/product",
    icon: <RiStore2Line />,
    name: "ร้านค้า",
    permissions: [
      "dev",
      "superAdmin",
      "admin",
      "superAccount",
      "account",
      "superScanner",
      "marketing",
      "scanner",
      "inventory",
    ],
    children: [
      {
        path: "/product/manage",
        component: <ManageProducts />,
        name: "จัดการสินค้า",
        permissions: [
          "dev",
          "superAdmin",
          "superScanner",
          "scanner",
          "marketing",
          "inventory",
          "admin",
        ],
      },

      {
        path: "/product/orders",
        component: <ProductOrders />,
        name: "คำสั่งซื้อสินค้า",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superScanner",
          "scanner",
          "marketing",
          "superAccount",
          "account",

        ],
      },
      {
        path: "/product/orders/point",
        icon: <TbBrandProducthunt />,
        component: <ProductOrders isPoint={true} />,
        name: "คำขอแลกคะแนน",

        permissions: [
          "dev",
          "admin",
          "superAdmin",
          "superAccount",

        ],
      },
      {
        path: "/reports/shop",
        component: <ReportShop />,
        name: "รายงานร้านค้า",
        permissions: [
          "dev",
          "superAdmin",
          "superScanner",
          "superAccount",
          "account",
          "marketing",

        ],
      },
      // {
      //   path: "/reports/point",
      //   component: <ReportPointRedeem />,
      //   name: "รายงานแลกคะแนน",
      //   permissions: [
      //     "dev",
      //     "superAdmin",
      //     "superScanner",
      //     "superAccount",
      //     "account",
      //     "marketing",
      //   ],
      // },
      {
        path: "/product/order/create/:userId",
        component: <CreateProductOrder />,
        name: "สร้างคำสั่งซื้อสินค้า",
        hideSideBar: true,
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superAccount",
          "account",
          "marketing",
        ],
      },
      {
        path: "/product/order/:orderId",
        component: <ProductOrderInfo />,
        name: "รายระเอียดคำสั่งซื้อสินค้า",
        hideSideBar: true,
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superAccount",
          "account",
          "marketing",
          "scanner",
        ],
      },
    ],
  },

  {
    path: "/donate",
    icon: <BiDonateHeart />,
    name: "บริจาค",
    permissions: ["dev", "superAdmin", "admin", "superAccount"],
    children: [
      {
        path: "/donate/manage",
        component: <ManageDonate />,
        name: "จัดการบริจาค",
        permissions: ["dev", "admin", "superAdmin", "superAccount"],
      },

      {
        path: "/donate/orders",
        component: <DonateOrders />,
        name: "บริจาคทั้งหมด",
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superAccount",
          "marketing",
        ],
      },

      {
        path: "/donate/order/:orderId",
        component: <DonateOrderInfo />,
        name: "รายระเอียดออเดอร์บริจาค",
        hideSideBar: true,
        permissions: [
          "dev",
          "superAdmin",
          "admin",
          "superAccount",
          "marketing",
        ],
      },
    ],
  },

  {
    path: "/missions",
    icon: <GrBike />,
    name: "ภารกิจ",
    permissions: ["dev", "superAdmin", "admin"],
    children: [
      {
        path: "/mission/manage",
        component: <ManageMission />,
        name: "จัดการภารกิจ",
        permissions: ["dev", "superAdmin",],
      },
      {
        path: "/mission/orders",
        component: <MissionOrders />,
        name: "คำขอแลกรางวัลทั้งหมด",
        permissions: ["dev", "superAdmin", "admin"],
      },
      // {
      //   path: "/mission/order/:missionId",
      //   component: <MissionOrders />,
      //   hideSideBar: true,
      //   name: "คำขอแลกรางวัลทั้งหมด",
      //   permissions: ["dev", "superAdmin", "admin"],
      // },

      {
        path: "/mission/:missionId",
        component: <MissionDetail />,
        hideSideBar: true,
        name: "รายละเอียดภารกิจ",
        permissions: ["dev", "superAdmin", "admin"],
      },
    ],
  },
  {
    path: "/surveys",
    icon: <FaStar />,
    component: <SurveysPage />,
    name: "แบบสำรวจ",
    permissions: ["dev", "superAdmin", 'admin'],
    children: [],
  },
  {
    path: "/affiliate",
    icon: <GiThreeFriends />,
    component: <AffiliateOrder />,
    name: "รายได้ชวนเพื่อน",
    permissions: ["dev", "superAdmin"],
    children: [],
  },
  {
    path: "/withdraw",
    icon: <BiMoneyWithdraw />,
    name: "ถอนเงิน",
    permissions: ["dev", "admin", "superAdmin", "superAccount"],
    children: [
      {
        path: "/withdraw/all",
        component: <WithdrawList />,
        name: "คำขอถอนเงินทั้งหมด",
        permissions: ["dev", "admin", "superAdmin", "superAccount"],
      },
      {
        path: "/withdraw/pending",
        component: <WithdrawPendingList />,
        name: "คำขอถอนเงินรอดำเนินการ",
        permissions: ["dev", "admin", "superAdmin", "superAccount"],
      },
      {
        path: "/withdraw/approved",
        component: <WithdrawApprovedList />,
        name: "คำขอถอนเงินสำเร็จ",
        permissions: ["dev", "admin", "superAdmin", "superAccount"],
      },
    ],
  },

  {
    path: "/users",
    icon: <FiUsers />,
    name: "ลูกค้า",
    permissions: ["dev", "superAdmin", "admin"],
    children: [
      {
        path: "/users",
        component: <Users />,
        name: "ค้นหาลูกค้า",
        permissions: ["dev", "superAdmin", "admin"],
      },
      {
        hideSideBar: true,
        path: "/user/:userId",
        component: <UserInfo />,
        name: "รายละเอียดลูกค้า",
        permissions: ["dev", "superAdmin", "admin"],
      },

      // {
      //   path: "/users/new",
      //   component: <CreateUser />,
      //   name: "สร้างบัญชีผู้ใช่ใหม่",
      //   permissions: ["dev", "superAdmin", "admin"],
      // },
      {
        path: "/user/create",
        component: <UserCreate />,
        name: "สร้างบัญชีผู้ใช้ใหม่",
        permissions: ["dev", "superAdmin", "admin"],
      },

      // {
      //   path: "/reports/rounddate-user",
      //   component: <ReportRounddateNewUser />,
      //   name: "รายงานผู้ใช้ใหม่รายงวด",
      //   permissions: ["dev", "superAdmin"],
      // },
    ],
  },
  {
    path: "/admins",
    icon: <RiAdminLine />,
    component: <Admins />,
    name: "พนักงาน",
    permissions: ["dev"],
    children: [],
  },
  {
    path: "/complains",
    component: <Complains />,
    icon: <FiFrown />,
    name: "ร้องเรียน",
    permissions: ["dev", "superAdmin", "admin", "marketing"],
    children: [],
  },
  {
    path: "/prizes",
    // Component: <Prizes />,
    icon: <FiGift />,
    name: "รางวัล",
    permissions: ["dev", "superScanner", "superAccount"],
    children: [
      {
        path: "/prizes-makeReward",
        component: <MakeReward />,
        name: "สร้างรางวัล",
        permissions: ["dev"],
      },
      {
        path: "/prizes-list",
        component: <PrizesList />,
        name: "รางวัลรายบุคคล",
        permissions: ["dev", "superScanner", "superAccount"],
      },
      {
        path: "/reports/prizes-user",
        component: <ReportWinner />,
        name: "รายงานผู้ถูกรางวัล",
        permissions: ["dev", "superScanner", "superAccount"],
      },
      {
        path: "/reports/prizes-book",
        component: <ReportWinnerBook />,
        name: "รายงานสรุปรางวัล",
        permissions: ["dev", "superScanner", "superAccount", "account"],
      },
      // {
      //   hideSideBar: true,
      //   path: "/prizes-list/:userId",
      //   Component: <UserPrize />,
      //   name: "รางวัลเฉพาะบุคคล",
      //   permissions: ["dev", "account", "admin", "superScanner", "superAdmin"],
      // },
      // {
      //   path: "/prizes-list/lotteriesPrizes",
      //   Component: <LotteriesPrizes />,
      //   name: "เล่มที่ถูกรางวัล",
      //   permissions: ["dev", "account", "admin", "superScanner", "superAdmin"],
      // },
    ],
  },
  {
    path: "/logs",
    component: <LogList />,
    icon: <FiVideo />,
    name: "บันทึกระบบ",
    children: [],
    permissions: ["dev"],
  },
  {
    path: "/reports",
    icon: <FiFileText />,
    name: "รายงาน",
    permissions: [
      "dev",
      "superAdmin",
      "superScanner",
      "superAccount",
      "admin",
      "account",
      "marketing",
    ],
    children: [
      // 1. ยอดขายและคำสั่งซื้อ
      {
        group: "ยอดขายและคำสั่งซื้อ",
        path: "/reports/daily",
        component: <ReportDailySale />,
        name: "รายงานยอดขายรายวัน",
        permissions: ["dev", "superAdmin", "admin", "superAccount"],
      },
      {
        group: "ยอดขายและคำสั่งซื้อ",
        path: "/reports/daily/hourly",
        component: <ReportDailySaleHourly />,
        name: "รายละเอียดคำสั่งซื้อรายชั่วโมง",
        permissions: ["dev", "superAdmin", "admin", "superAccount"],
        hideSideBar: true,
      },
      {
        group: "ยอดขายและคำสั่งซื้อ",
        path: "/reports/order",
        component: <ReportOrder />,
        name: "รายงานคำสั่งซื้อสลาก",
        permissions: [
          "dev",
          "superAdmin",
          "superScanner",
          "superAccount",
          "account",
        ],
      },
      {
        group: "ยอดขายและคำสั่งซื้อ",
        path: "/reports/order/discount",
        component: <ReportOrderDiscount />,
        name: "รายงานคำสั่งซื้อสลากลดราคา",
        permissions: ["dev", "superAdmin", "superScanner", "superAccount"],
      },
      {
        group: "ยอดขายและคำสั่งซื้อ",
        path: "/reports/coupon",
        component: <ReportCoupon />,
        name: "รายงานคูปอง",
        permissions: ["dev", "superAdmin", "superAccount", "account"],
      },
      {
        group: "ยอดขายและคำสั่งซื้อ",
        path: "/reports/shop",
        component: <ReportShop />,
        name: "รายงานร้านค้า",
        permissions: [
          "dev",
          "superAdmin",
          "superScanner",
          "superAccount",
          "account",
          "marketing",
        ],
      },
      {
        group: "ยอดขายและคำสั่งซื้อ",
        path: "/reports/reserve-order",
        component: <ReportReserveOrder />,
        name: "รายงานสรุปสร้างออเดอร์จองสิทธิ์",
        permissions: [
          "dev",
          "superScanner",
          "superAdmin",
          "superAccount",
          "account",
        ],
      },

      // 2. ลูกค้าและสมาชิก
      {
        group: "ลูกค้าและสมาชิก",
        path: "/reports/top-buyer",
        component: <ReportTopBuyer />,
        name: "รายชื่อผู้ซื้อ Top 100",
        permissions: ["dev", "superAdmin", "marketing"],
      },
      {
        group: "ลูกค้าและสมาชิก",
        path: "/reports/buyer-list",
        component: <RoundDateBuyerList />,
        name: "รายชื่อผู้ซื้องวดนี้ทั้งหมด",
        permissions: ["dev", "admin", "superAdmin", "superAccount", "account"],
      },
      {
        group: "ลูกค้าและสมาชิก",
        path: "/reports/user-year",
        component: <ReportUserYear />,
        name: "รายงานผู้ซื้อรายปี",
        permissions: ["dev", "superAdmin"],
      },
      {
        group: "ลูกค้าและสมาชิก",
        path: "/reports/all-users",
        component: <ReportAllUser />,
        name: "รายงานผู้ใช้ทั้งหมด",
        permissions: ["dev", "superAdmin"],
      },
      {
        group: "ลูกค้าและสมาชิก",
        path: "/reports/rounddate-user",
        component: <ReportRounddateNewUser />,
        name: "รายงานผู้ใช้ใหม่รายงวด",
        permissions: ["dev", "superAdmin"],
      },
      {
        group: "ลูกค้าและสมาชิก",
        path: "/reports/user-summary",
        component: <ReportVerifiedUser />,
        name: "รานงานสรุปผู้ใช้ยืนยันตัวตน",
        permissions: ["dev", "superAdmin"],
      },

      // 3. รางวัลและคะแนนสะสม
      {
        group: "รางวัลและคะแนนสะสม",
        path: "/reports/reward-winner",
        component: <ReportRewardwinner />,
        name: "รายงานผู้ถูกรางวัล",
        permissions: ["dev", "superAdmin", "superAccount", "account"],
      },
      {
        group: "รางวัลและคะแนนสะสม",
        path: "/reports/prizes-book",
        component: <ReportWinnerBook />,
        name: "รายงานสรุปรางวัล",
        permissions: ["dev", "superScanner", "superAccount", "account"],
      },
      {
        group: "รางวัลและคะแนนสะสม",
        path: "/reports/point",
        component: <ReportPointRedeem />,
        name: "รายงานแลกคะแนน",
        permissions: [
          "dev",
          "superAdmin",
          "superScanner",
          "superAccount",
          "account",
          "marketing",
        ],
      },
      {
        group: "รางวัลและคะแนนสะสม",
        path: "/reports/report-alert-userprizes",
        component: <ReportUserPrizes />,
        name: "รายงานการแจ้งเตือนผู้ถูกรางวัล",
        permissions: ["dev"],
      },

      // 4. จัดส่งและคลังสลาก
      {
        group: "จัดส่งและคลังสลาก",
        path: "/reports/mail",
        component: <ReportMails />,
        name: "รายงานไปรษณีย์",
        permissions: [
          "dev",
          "superAdmin",
          "superScanner",
          "superAccount",
          "account",
        ],
      },
      {
        group: "จัดส่งและคลังสลาก",
        path: "/reports/book-summary",
        component: <ReportLotterieBooksImport />,
        name: "รายงานการนำเข้าเล่มสลาก",
        permissions: ["dev", "superScanner", "scanner", "superAdmin"],
      },

      // 5. การเงิน ภาษี และผลงาน
      {
        group: "การเงิน ภาษี และผลงาน",
        path: "/reports/tax/lottery",
        component: <ReportTaxInvoice />,
        name: "รายงานภาษี - สลาก",
        permissions: ["dev", "superAccount", "account"],
      },
      {
        group: "การเงิน ภาษี และผลงาน",
        path: "/reports/tax/coupon",
        component: <ReportTaxCoupon />,
        name: "รายงานภาษี - คูปอง",
        permissions: ["dev", "superAccount", "account"],
      },
      {
        group: "การเงิน ภาษี และผลงาน",
        path: "/reports/order/net-income",
        component: <ReportNetIncome />,
        name: "รายงานค่าเช่าพื้นที่ฝากและบริการ",
        permissions: ["dev", "superAdmin", "superAccount", "account"],
      },
      {
        group: "การเงิน ภาษี และผลงาน",
        path: "/reports/affiliate",
        component: <ReportAffiliate />,
        name: "รายงานรายได้ชวนเพื่อน",
        permissions: ["dev", "superAdmin", "account"],
      },
      {
        group: "การเงิน ภาษี และผลงาน",
        path: "/reports/admin-approved",
        component: <ReportAdminApproved />,
        name: "รายงานแอดมินอนุมัติออเดอร์",
        permissions: ["dev", "superAdmin"],
      },
      {
        group: "การเงิน ภาษี และผลงาน",
        path: "/reports/admin",
        component: <ReportAdminCommission />,
        name: "รายงานแอดมิน",
        permissions: ["dev", "superAdmin"],
      },

      // 6. รายงานอื่นๆ
      {
        group: "รายงานอื่นๆ",
        path: "/reports/button-click",
        component: <ReportButtonClick />,
        name: "รายงานการกดปุ่ม",
        permissions: ["dev", "superAdmin"],
      },
    ],
  },
  // {
  //   path: "/settings",
  //   component: <Settings />,
  //   icon: <FiSettings />,
  //   name: "ตั้งค่า",
  //   children: [],
  //   permissions: ["dev", "superAdmin"],
  // },
  {
    path: "/tracking-links",
    icon: <FiLink />,
    name: "Tracking Links",
    permissions: ["dev", "superAdmin", 'admin'],
    children: [
      {
        path: "/tracking-links/manage",
        component: <ManageTrackingLinks />,
        name: "จัดการ Tracking Links",
        permissions: ["dev", "superAdmin", 'admin'],
      },
      {
        path: "/tracking-links/detail",
        component: <TrackingLinkDetail />,
        name: "รายละเอียด Tracking Link",
        permissions: ["dev", "superAdmin", 'admin'],
        hideSideBar: true,
      },
    ],
  },
  {
    path: "/sales-closing",
    icon: <FiCheckSquare />,
    name: "ปิดงวด",
    permissions: ["dev"],
    children: [{ path: "/sales-closing/control", component: <SalesClosing />, name: "ควบคุมปิดงวด", permissions: ["dev"] }],
  },
  {
    path: "/setting",
    icon: <FiSettings />,
    name: "ตั้งค่า",
    permissions: ["dev", "superAdmin"],
    children: [
      {
        path: "/general",
        component: <General />,
        name: "ทั่วไป",
        permissions: ["dev", "superAdmin"],
      },
      {
        path: "/mail",
        component: <MailSetting />,
        name: "ไปรษณีย์",
        permissions: ["dev", "superAdmin"],
      },
      {
        path: "/prices",
        component: <Prices />,
        name: "ราคาและค่าเงิน",
        permissions: ["dev", "superAdmin"],
      },
      {
        path: "/price",
        component: <Price />,
        name: "-",
        permissions: ["dev"],
      },
      {
        path: "/tools",
        component: <Tools />,
        name: "เครื่องมือ",
        permissions: ["dev"],
      },
      {
        path: "/popup",
        component: <Popup />,
        name: "ป๊อปอัพ",
        permissions: ["dev", "superAdmin", "admin"],
      },
      {
        path: "/banner",
        component: <Banners />,
        name: "แบนเนอร์",
        permissions: ["dev", "superAdmin", "admin"],
      },
    ],
  },
  {
    path: "/dev",
    icon: <FiCheckSquare />,
    name: "Dev Tools",
    permissions: ["dev"],
    children: [
      {
        path: "/dev/monitor",
        component: <DevMonitor />,
        name: "Admin Realtime Monitor",
        permissions: ["dev"],
        allowedUserIds: ["201989"],
      },
      {
        path: "/dev/all-in-one-draw",
        component: <AllInOneDraw />,
        name: "All-in-One ปิดงวด",
        permissions: ["dev", 'superAdmin', 'admin'],
      },
    ],
  },
];
export const childPages = pages.reduce((acc, x) => {
  return [...acc, ...(x.children || [])];
}, []);

export default pages;
